import { ApplicationState } from '@/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import AfferoLogo from '../../assets/afferolab_logo_white.svg';
import OrgNotFoundImg from '../../assets/not-found-img.svg';
import './styles.scss';

const OrganizationNotFound: React.FC = () => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (['http://localhost:3000/#/', 'https://dev.afferolab.net:3000/#/'].indexOf(window.location.href) !== -1) {
            window.location.href = window.location.href.split('/#/').join('/cast/afferolab/#/');
        }
    }, [location, history]);

    return (
        <div className="organization-not-found-container">
            <header className="header">
                <div className="container header-container">
                    <img alt="logo afferolab" className="logo" src={AfferoLogo} />
                </div>

                <div className="header-bottom-divider" />
            </header>

            <div className="content container">
                <div>
                    <div className="text-container">
                        <h4>{strings.ORGANIZATION_NOT_FOUND_TITLE}</h4>
                        <p>{strings.ORGANIZATION_NOT_FOUND_MESSAGE}</p>
                    </div>

                    <img alt="" src={OrgNotFoundImg} />
                </div>
            </div>
        </div>
    );
};

export default OrganizationNotFound;
